import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wage-process-container" }
const _hoisted_2 = { class: "dense-header" }
const _hoisted_3 = { class: "title-group" }
const _hoisted_4 = { class: "title-text" }
const _hoisted_5 = { class: "months-dense-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  class: "month-card-front",
  style: {"cursor":"pointer"}
}
const _hoisted_8 = { class: "month-card-top" }
const _hoisted_9 = { class: "month-title" }
const _hoisted_10 = { class: "month-number" }
const _hoisted_11 = { class: "month-card-upload-area" }
const _hoisted_12 = {
  key: 3,
  class: "progress-info"
}
const _hoisted_13 = {
  class: "progress-text-small",
  style: {"z-index":"1","background-color":"white"}
}

import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

interface WageProcessData {
  wp_ym: string;
  wp_step1_completed: number;
  wp_step2_completed: number;
  wp_step3_completed: number;
  wp_step4_completed: number;
  wp_current_step: number;
}

interface WageMagamData {
  wm_ym: string;
  wm_job_type: string;
  wm_count: string;
  wm_wage_sum: string;
  wm_isuse: 'y' | 'n';
}

interface MonthStatus {
  hasProcess: boolean;
  currentStep: number;
  progress: number;
  isClosed: boolean;
  employeeCount: number;
  totalWage: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WageProcessStatus',
  props: {
    selectedYear: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const router = useRouter();

const isLoading = ref(false);
const loadingText = ref('데이터를 불러오는 중...');
const currentMonth = ref(new Date().getMonth() + 1);
const wageProcessData = ref<WageProcessData[]>([]);
const wageMagamData = ref<WageMagamData[]>([]);

// 월별 상태 계산
const getMonthStatus = (month: number): MonthStatus => {
  const ym = `${props.selectedYear}${String(month).padStart(2, '0')}`;
  
  // 프로세스 데이터 찾기
  const processData = wageProcessData.value.find(p => p.wp_ym === ym);
  
  // 마감 데이터 찾기 (전체합계)
  const magamData = wageMagamData.value.find(
    m => m.wm_ym === ym && m.wm_job_type === '전체합계' && m.wm_isuse === 'y'
  );
  
  // 프로세스가 있는 경우
  if (processData) {
    const completedSteps = [
      processData.wp_step1_completed,
      processData.wp_step2_completed,
      processData.wp_step3_completed,
      processData.wp_step4_completed
    ].filter(s => s === 1).length;
    
    return {
      hasProcess: true,
      currentStep: processData.wp_current_step || completedSteps,
      progress: (completedSteps / 4) * 100,
      isClosed: !!magamData,
      employeeCount: magamData ? parseInt(magamData.wm_count) || 0 : 0,
      totalWage: magamData ? parseInt(magamData.wm_wage_sum) || 0 : 0
    };
  }
  
  // 마감만 있는 경우
  if (magamData) {
    return {
      hasProcess: false,
      currentStep: 4,
      progress: 100,
      isClosed: true,
      employeeCount: parseInt(magamData.wm_count) || 0,
      totalWage: parseInt(magamData.wm_wage_sum) || 0
    };
  }
  
  // 아무것도 없는 경우
  return {
    hasProcess: false,
    currentStep: 0,
    progress: 0,
    isClosed: false,
    employeeCount: 0,
    totalWage: 0
  };
};

// 월 클릭 핸들러
const handleMonthClick = (month: number) => {
  const ym = `${props.selectedYear}${String(month).padStart(2, '0')}`;
  
  // Store에 연월 정보 설정 (YearMonthSelector가 이 값을 사용)
  store.commit('setLebYm', ym);
  
  // 라우터 이동
  router.push('/pgm/wage/WageProcess');
};

// 데이터 조회
const fetchData = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code) {
    console.warn('사용자 정보가 없습니다.');
    return;
  }

  try {
    isLoading.value = true;
    loadingText.value = '임금관리 현황을 불러오는 중...';
    
    // 프로세스 데이터 조회 (해당 연도 1-12월)
    const processPromises = Array.from({ length: 12 }, (_, i) => {
      const month = i + 1;
      const ym = `${props.selectedYear}${String(month).padStart(2, '0')}`;
      
      return axios.get('/api/wage-process/status', {
        params: {
          sisulCode: user.m_sisul_code,
          yearMonth: ym
        },
        withCredentials: true
      }).then(res => res.data.data).catch(() => null);
    });
    
    const processResults = await Promise.all(processPromises);
    wageProcessData.value = processResults.filter(r => r !== null);
    
    // 마감 데이터 조회
    const magamResponse = await axios.get(`/api/calc/wage-magam-yearly/${user.m_sisul_code}/${props.selectedYear}`, {
      withCredentials: true
    });
    
    if (magamResponse.data.success) {
      wageMagamData.value = magamResponse.data.data || [];
    }
    
  } catch (error) {
    console.error('임금관리 현황 조회 오류:', error);
  } finally {
    isLoading.value = false;
  }
};

// 연도 변경 시 데이터 다시 조회
watch(() => props.selectedYear, () => {
  fetchData();
}, { immediate: true });

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: loadingText.value
    }, null, 8, ["is-visible", "text"]),
    _createVNode(_component_v_card, {
      class: "file-upload-card-dense",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              color: "#64748b",
              size: "20"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-chart-timeline-variant", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(__props.selectedYear) + "년 임금관리 현황", 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "월별 임금 관리 프로세스 및 마감 상태를 확인하세요", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month) => {
            return _createElementVNode("div", {
              key: month,
              class: _normalizeClass(["month-card-dense", { 
            'current': month === currentMonth.value,
            'completed': getMonthStatus(month).isClosed,
            'closed': getMonthStatus(month).isClosed
          }]),
              onClick: ($event: any) => (handleMonthClick(month))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(month) + "월", 1),
                    (month === currentMonth.value)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "#1e3a8a",
                          size: "x-small",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" NOW ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (getMonthStatus(month).isClosed)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          color: "#0f172a",
                          size: "x-small",
                          variant: "flat",
                          class: "ml-1"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" 마감완료 ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (getMonthStatus(month).isClosed)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "tonal",
                        color: "#1e3a8a",
                        size: "small",
                        "prepend-icon": "mdi-lock-check",
                        class: "file-submit-btn"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" 마감완료 ", -1)
                        ]))]),
                        _: 1
                      }))
                    : (getMonthStatus(month).hasProcess)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          variant: "tonal",
                          color: "#1e3a8a",
                          size: "small",
                          "prepend-icon": "mdi-progress-check",
                          class: "file-submit-btn"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 진행중 (Step " + _toDisplayString(getMonthStatus(month).currentStep) + "/4) ", 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 2,
                          variant: "tonal",
                          color: "grey",
                          size: "small",
                          "prepend-icon": "mdi-minus-circle",
                          disabled: "",
                          class: "file-submit-btn"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" 미진행 ", -1)
                          ]))]),
                          _: 1
                        })),
                  (getMonthStatus(month).hasProcess || getMonthStatus(month).isClosed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_v_progress_linear, {
                          "model-value": getMonthStatus(month).progress,
                          color: getMonthStatus(month).isClosed ? '#10b981' : '#1e3a8a',
                          height: "4",
                          class: "progress-bar-small"
                        }, null, 8, ["model-value", "color"]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(Math.round(getMonthStatus(month).progress)) + "%", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 10, _hoisted_6)
          }), 64))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})